import { Dialog, Box, Typography, Button, IconButton } from '@mui/material'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import CloseIcon from '@mui/icons-material/Close'

interface PreviewDialogProps {
  open: boolean
  careerId: string
  pdfContentDocumentId?: string | null
  instanceUrl?: string
  generatingPDF: boolean
  onClose: () => void
  onGeneratePDF: () => void
}

export function PreviewDialog({
  open,
  careerId,
  pdfContentDocumentId,
  instanceUrl,
  generatingPDF,
  onClose,
  onGeneratePDF,
}: PreviewDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          height: '100vh',
          width: '700px',
          maxWidth: '700px',
          m: 0,
        },
      }}
    >
      {/* ダイアログヘッダー */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2,
          borderBottom: 1,
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Typography variant="h6">プレビュー</Typography>
        <Box sx={{ display: 'flex', gap: 1 }}>
          {/* 既存PDFへのリンク（PDFContentDocumentId__cがある場合のみ表示） */}
          {pdfContentDocumentId && instanceUrl && (
            <Button
              variant="outlined"
              startIcon={<OpenInNewIcon />}
              onClick={() => {
                const pdfUrl = `${instanceUrl}/lightning/r/ContentDocument/${pdfContentDocumentId}/view`
                window.open(pdfUrl, '_blank')
              }}
            >
              PDF
            </Button>
          )}
          <Button variant="contained" startIcon={<PictureAsPdfIcon />} onClick={onGeneratePDF} disabled={generatingPDF}>
            {generatingPDF ? 'PDF作成中...' : 'PDF作成'}
          </Button>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </Box>

      {/* プレビューiframe */}
      <Box sx={{ flexGrow: 1, overflow: 'hidden' }}>
        <iframe
          src={`/editor/${careerId}/preview`}
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
          title="PRシートプレビュー"
        />
      </Box>
    </Dialog>
  )
}
